// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { Suspense, StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { Auth0Provider } from '@auth0/auth0-react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { BreakpointProvider, ToastContainer } from '@teamnine/pcj-ui-v2'

import { buildInfo } from '@/buildInfo'
import App from '@/App'
import AppTheme from '@/theme/AppTheme'
import FullPageLoader from '@/app/shared/components/FullPageLoader'
import reportWebVitals from './reportWebVitals'

console.info(
  `TCC Web Client — version: ${buildInfo.version}, commit: ${buildInfo.commit}, built: ${buildInfo.date}`
)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

const container = document.getElementById('root')
if (container) {
  const root = ReactDOM.createRoot(container)
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <Auth0Provider
          domain={import.meta.env.VITE_AUTH0_DOMAIN || ''}
          clientId={import.meta.env.VITE_AUTH0_CLIENT_ID || ''}
          organization={import.meta.env.VITE_AUTH0_ORGANIZATION_ID}
          redirectUri={window.location.origin}
          audience={import.meta.env.VITE_AUTH0_AUDIENCE}
          cacheLocation="localstorage"
          useRefreshTokens
        >
          <AppTheme>
            <BreakpointProvider>
              <ToastContainer />
              <Suspense fallback={<FullPageLoader />}>
                <App />
              </Suspense>
            </BreakpointProvider>
          </AppTheme>
        </Auth0Provider>
      </QueryClientProvider>
    </StrictMode>
  )
}

reportWebVitals()
